import * as $int from "../gleam_stdlib/gleam/int.mjs";
import * as $p5js_gleam from "../p5js_gleam/p5js_gleam.mjs";
import * as $p5 from "../p5js_gleam/p5js_gleam/bindings.mjs";
import { CustomType as $CustomType } from "./gleam.mjs";

export class Left extends $CustomType {}
export const Direction$Left = () => new Left();
export const Direction$isLeft = (value) => value instanceof Left;

export class Right extends $CustomType {}
export const Direction$Right = () => new Right();
export const Direction$isRight = (value) => value instanceof Right;

export class Top extends $CustomType {}
export const Direction$Top = () => new Top();
export const Direction$isTop = (value) => value instanceof Top;

export class Bottom extends $CustomType {}
export const Direction$Bottom = () => new Bottom();
export const Direction$isBottom = (value) => value instanceof Bottom;

export class TopLeft extends $CustomType {}
export const Direction$TopLeft = () => new TopLeft();
export const Direction$isTopLeft = (value) => value instanceof TopLeft;

export class TopRight extends $CustomType {}
export const Direction$TopRight = () => new TopRight();
export const Direction$isTopRight = (value) => value instanceof TopRight;

export class BottomLeft extends $CustomType {}
export const Direction$BottomLeft = () => new BottomLeft();
export const Direction$isBottomLeft = (value) => value instanceof BottomLeft;

export class BottomRight extends $CustomType {}
export const Direction$BottomRight = () => new BottomRight();
export const Direction$isBottomRight = (value) => value instanceof BottomRight;

/**
 * Represents a room and its walls.
 * For each direction, True means that direction is navigable (no wall).
 */
export class Room extends $CustomType {
  constructor(left, right, top, bottom, top_left, top_right, bottom_left, bottom_right) {
    super();
    this.left = left;
    this.right = right;
    this.top = top;
    this.bottom = bottom;
    this.top_left = top_left;
    this.top_right = top_right;
    this.bottom_left = bottom_left;
    this.bottom_right = bottom_right;
  }
}
export const Room$Room = (left, right, top, bottom, top_left, top_right, bottom_left, bottom_right) =>
  new Room(left,
  right,
  top,
  bottom,
  top_left,
  top_right,
  bottom_left,
  bottom_right);
export const Room$isRoom = (value) => value instanceof Room;
export const Room$Room$left = (value) => value.left;
export const Room$Room$0 = (value) => value.left;
export const Room$Room$right = (value) => value.right;
export const Room$Room$1 = (value) => value.right;
export const Room$Room$top = (value) => value.top;
export const Room$Room$2 = (value) => value.top;
export const Room$Room$bottom = (value) => value.bottom;
export const Room$Room$3 = (value) => value.bottom;
export const Room$Room$top_left = (value) => value.top_left;
export const Room$Room$4 = (value) => value.top_left;
export const Room$Room$top_right = (value) => value.top_right;
export const Room$Room$5 = (value) => value.top_right;
export const Room$Room$bottom_left = (value) => value.bottom_left;
export const Room$Room$6 = (value) => value.bottom_left;
export const Room$Room$bottom_right = (value) => value.bottom_right;
export const Room$Room$7 = (value) => value.bottom_right;

const room_color = "#cbe3ed";

const wall_color = "#42aad6";

const wall_shadow_color = "#3c3c3c";

const wall_shadow_color2 = "#646464";

/**
 * Finds the opposite direction of the one passed in.
 */
export function inverse_direction(direction) {
  if (direction instanceof Left) {
    return new Right();
  } else if (direction instanceof Right) {
    return new Left();
  } else if (direction instanceof Top) {
    return new Bottom();
  } else if (direction instanceof Bottom) {
    return new Top();
  } else if (direction instanceof TopLeft) {
    return new BottomRight();
  } else if (direction instanceof TopRight) {
    return new BottomLeft();
  } else if (direction instanceof BottomLeft) {
    return new TopRight();
  } else {
    return new TopLeft();
  }
}

/**
 * Creates a room with only walls.
 */
export function initialize_unbounded_room() {
  return new Room(false, false, false, false, false, false, false, false);
}

/**
 * Creates a room with the wall to a given direction set to the passed value.
 */
export function set_navigable(room, direction, navigable_value) {
  if (direction instanceof Left) {
    return new Room(
      navigable_value,
      room.right,
      room.top,
      room.bottom,
      room.top_left,
      room.top_right,
      room.bottom_left,
      room.bottom_right,
    );
  } else if (direction instanceof Right) {
    return new Room(
      room.left,
      navigable_value,
      room.top,
      room.bottom,
      room.top_left,
      room.top_right,
      room.bottom_left,
      room.bottom_right,
    );
  } else if (direction instanceof Top) {
    return new Room(
      room.left,
      room.right,
      navigable_value,
      room.bottom,
      room.top_left,
      room.top_right,
      room.bottom_left,
      room.bottom_right,
    );
  } else if (direction instanceof Bottom) {
    return new Room(
      room.left,
      room.right,
      room.top,
      navigable_value,
      room.top_left,
      room.top_right,
      room.bottom_left,
      room.bottom_right,
    );
  } else if (direction instanceof TopLeft) {
    return new Room(
      room.left,
      room.right,
      room.top,
      room.bottom,
      navigable_value,
      room.top_right,
      room.bottom_left,
      room.bottom_right,
    );
  } else if (direction instanceof TopRight) {
    return new Room(
      room.left,
      room.right,
      room.top,
      room.bottom,
      room.top_left,
      navigable_value,
      room.bottom_left,
      room.bottom_right,
    );
  } else if (direction instanceof BottomLeft) {
    return new Room(
      room.left,
      room.right,
      room.top,
      room.bottom,
      room.top_left,
      room.top_right,
      navigable_value,
      room.bottom_right,
    );
  } else {
    return new Room(
      room.left,
      room.right,
      room.top,
      room.bottom,
      room.top_left,
      room.top_right,
      room.bottom_left,
      navigable_value,
    );
  }
}

/**
 * Checks if a direction is navigable from the given room.
 */
export function is_navigable(room, direction) {
  if (direction instanceof Left) {
    return room.left;
  } else if (direction instanceof Right) {
    return room.right;
  } else if (direction instanceof Top) {
    return room.top;
  } else if (direction instanceof Bottom) {
    return room.bottom;
  } else if (direction instanceof TopLeft) {
    return room.top_left;
  } else if (direction instanceof TopRight) {
    return room.top_right;
  } else if (direction instanceof BottomLeft) {
    return room.bottom_left;
  } else {
    return room.bottom_right;
  }
}

/**
 * Draws a room onto the screen at the given row and column.
 */
export function draw(p, room, room_column, room_row, room_size) {
  let top = $int.to_float(room_row * room_size);
  let bot = $int.to_float((room_row + 1) * room_size);
  let left = $int.to_float(room_column * room_size);
  let right = $int.to_float((room_column + 1) * room_size);
  $p5.stroke_weight(p, 1);
  $p5.fill(p, room_color);
  $p5.stroke(p, room_color);
  $p5.rect(p, left, top, $int.to_float(room_size), $int.to_float(room_size));
  $p5.stroke_weight(p, 4);
  $p5.stroke(p, wall_shadow_color);
  $p5.line(p, right + 2.0, top, right + 2.0, bot);
  $p5.line(p, left + 3.0, bot + 2.0, right + 2.0, bot + 2.0);
  $p5.stroke_weight(p, 3);
  $p5.stroke(p, wall_shadow_color2);
  $p5.line(p, right + 1.0, top, right + 1.0, bot);
  $p5.line(p, left + 2.0, bot + 1.0, right + 1.0, bot + 1.0);
  $p5.stroke(p, wall_color);
  $p5.stroke_weight(p, 2);
  let $ = room.left;
  if ($) {
    p
  } else {
    $p5.line(p, left, top, left, bot)
  }
  let $1 = room.right;
  if ($1) {
    p
  } else {
    $p5.line(p, right, top, right, bot)
  }
  let $2 = room.top;
  if ($2) {
    p
  } else {
    $p5.line(p, left, top, right, top)
  }
  let $3 = room.bottom;
  if ($3) {
    return p;
  } else {
    return $p5.line(p, left, bot, right, bot);
  }
}
